// Node representing a forked campaign — rendered at the target of a dashed
// fork edge. Clicking the node navigates to the forked campaign.

import { Handle, Position } from '@xyflow/react';
import { Link } from 'react-router-dom';
import { fallbackTheme } from './theme';
import { NODE_SIZES } from './provenanceLayout';

export interface ForkNodeData {
  campaignId: string;
  atIteration: number;
  label?: string;
}

export default function ForkNode({ data }: { data: ForkNodeData }) {
  const t = fallbackTheme;
  const { width, height } = NODE_SIZES.fork;
  return (
    <div
      style={{
        width,
        height,
        background: t.surface,
        border: `1px dashed ${t.forkEdge}`,
        borderRadius: 10,
        padding: '10px 12px',
        color: t.text,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <div style={{ fontSize: 10, color: t.textMuted, textTransform: 'uppercase', letterSpacing: 0.5 }}>
        Fork
      </div>
      <Link
        to={`/campaigns/${data.campaignId}`}
        style={{ fontSize: 13, fontWeight: 600, color: t.accent, textDecoration: 'none' }}
      >
        {data.label ?? shortCampaignId(data.campaignId)}
      </Link>
      <div style={{ fontSize: 11, color: t.textMuted }}>from iter {data.atIteration}</div>
      <Handle type="target" position={Position.Top} style={{ background: t.border }} />
    </div>
  );
}

function shortCampaignId(id: string): string {
  if (id.length <= 10) return id;
  return `${id.slice(0, 6)}…${id.slice(-4)}`;
}
